<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>ព័ត៌មានអតិថិជន</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដអតិថិជន</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.hash_id).length > 0">{{client.hash_id}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.name).length > 0">{{client.name}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>លេខទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.phone).length > 0">{{client.phone}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>Client Detail</h3> -->
				<md-table>
					<md-table-row>
						<md-table-cell>ថ្ងៃបានបង្កើត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.created_date).length > 0">{{config.datelify(client.created_date)}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំផ្សេងៗ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(client.note).length > 0">{{client.note}}</span>
							<span v-else>N/A</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3>កញ្ចប់ឥវ៉ាន់របស់អតិថិជនទាំងអស់</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-100">
				<md-card v-for="(loan, index) in loanList">
					<md-card-header data-background-color="orange">
						<h4 class="title">{{index+1}} - {{loan.hash_id}}</h4>
					</md-card-header>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-45">
								<table>
									<tr>
										<td style="width: 150px">Loan amount</td>
										<td style="width: 40px">:</td>
										<td>{{config.moneylify(loan.amount)}}</td>
									</tr>
									<tr>
										<td>Loan term</td>
										<td>:</td>
										<td>{{loan.term}} Months</td>
									</tr>
									<tr>
										<td>Interest rate</td>
										<td>:</td>
										<td>{{loan.interest_rate}}%</td>
									</tr>
									<tr>
										<td>Total interest</td>
										<td>:</td>
										<td>{{config.moneylify(loan.interest_amount)}}</td>
									</tr>
									<tr>
										<td>Loan fee</td>
										<td>:</td>
										<td>{{config.moneylify(loan.loan_fee)}}</td>
									</tr>
									<tr>
										<td>Total payment</td>
										<td>:</td>
										<td><b>{{config.moneylify(loan.total_payment)}}</b></td>
									</tr>
									<tr>
										<td>Status</td>
										<td>:</td>
										<td>
											<span class="green" v-if="loan.status == 'act'">{{config.getStatus(loan.status)}}</span>
											<span class="late" v-if="loan.status == 'fin'">{{config.getStatus(loan.status)}}</span>
										</td>
									</tr>

								</table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-45">
								<table style="border-width: 0px;">
									<tr>
										<td>Client</td>
										<td>:</td>
										<td><b>ID: {{loan.client_hash_id}}</b> ({{loan.name}})</td>
									</tr>
									<tr>
										<td style="width: 150px">Initial payment</td>
										<td style="width:40px">:</td>
										<td>{{config.moneylify(loan.initial_payment)}}</td>
									</tr>
									<tr>
										<td>Monthly payment</td>
										<td>:</td>
										<td>{{config.moneylify(loan.monthly_payment)}}</td>
									</tr>
									<tr>
										<td>Final payment</td>
										<td>:</td>
										<td>{{config.moneylify(loan.final_payment)}}</td>
									</tr>
									<tr>
										<td>Paid EMIs</td>
										<td>:</td>
										<td>{{loan.total_paid}} / {{loan.term}}</td>
									</tr>
									<!-- <tr>
										<td>Remaining balance</td>
										<td>:</td>
										<td>{{config.moneylify(loan.loan_balance)}}</td>
									</tr> -->
									<tr>
										<td>Loan period</td>
										<td>:</td>
										<td>{{config.datelify(loan.start_date)}} - {{config.datelify(loan.end_date)}}</td>
									</tr>
									<tr>
										<td>Next payment</td>
										<td>:</td>
										<td>
											<span v-if="loan.total_paid == loan.term">N/A</span>
											<span class="late"
												v-else-if="String(loan.next_payment).length >0 && config.timelify(loan.next_payment) == 'Late'">{{config.datelify(loan.next_payment)}}</span>
											<span class="green"
												v-else-if="String(loan.next_payment).length >0">{{config.datelify(loan.next_payment)}} ({{config.timelify(loan.next_payment)}})</span>

										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-10">
								<div class="md-layout">
									<div class="md-layout-item md-small-size-33 md-size-100 text-center">
										<router-link :to="'/loans/detail/' + loan.hash_id">
											<md-button class="md-just-icon md-simple md-success">
												<md-icon>visibility</md-icon>
												<md-tooltip md-direction="top">View loan information</md-tooltip>
											</md-button>
										</router-link>
									</div>
								</div>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>
		</div>
	</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {

			// this.getLocation();
			// this.getSettings();
			this.getClient();
			// this.searchHandler();
		},

		data() {
			return {
				tabName: "first",
				loaded: false,
				client: {
					hash_id: "",
					name: "",
					phone: "",
					note: "",
					created_date: ""
				},
				loanList: []

			}
		},
		methods: {
			getClient() {
				this.$http.get(this.config.api + "/admin/client/get/" + this.$route.params.hash_id).then(data => {
					this.client = data.body.data
					this.loaded = true;
				})
				// this.$http.get(this.config.api + "/admin/loan/get/client/" + this.$route.params.hash_id).then(data => {
				// 	this.loanList = data.body.data
				// })
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Payments/Detail.vue